import type { ScenarioDto } from "./scenario.dto";
import type { GetScenariosDto } from "./get-scenarios.dto";
import type { ScenarioCategoryDto } from "./scenario-category.dto";

import { api } from "../core/api";

export async function getScenarios(
  params?: GetScenariosDto
): Promise<ScenariosResponse> {
  const entries = Object.entries(params ?? {})
    .filter((it) => !!it[1])
    .map((it) => [it[0], String(it[1])]);
  const search = new URLSearchParams(entries);
  const res = await api.get<ScenariosResponse>(`/api/v1/tests?${search}`);
  return res.data;
}
export interface ScenariosResponse {
  data: ScenarioDto[];
  meta: { next_page?: number; total_items: number };
}

export async function getScenarioCategories(params?: {
  query?: string;
}): Promise<ScenarioCategoryDto[]> {
  const entries = Object.entries(params ?? {}).filter((it) => !!it[1]);
  const search = new URLSearchParams(entries);
  const { data } = await api.get(`/api/v1/test_categories?${search}`);
  return data.data;
}
